import { render } from "./SplashArea.vue?vue&type=template&id=34458df1&scoped=true"
import script from "./SplashArea.vue?vue&type=script&lang=js"
export * from "./SplashArea.vue?vue&type=script&lang=js"

import "./SplashArea.vue?vue&type=style&index=0&id=34458df1&scoped=true&lang=scss"
import "./SplashArea.vue?vue&type=style&index=1&id=34458df1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34458df1"]])

export default __exports__